







import axios from 'axios';
import Vue from 'vue';
import Spinner from 'vue-simple-spinner';
export default Vue.extend({
  name: 'NewEditor',
  components: { Spinner },
  mounted() {
    // Would make a request to the server to create a blank podpast with a private code and a sharable code
    // const randomID = 'fkdfklsjfl';
    this.$router.push({
      name: 'editor',
      params: {
        providedid: 'new' // response.data.successResponse.publicID + '_' + response.data.successResponse.privateID,
      },
    });
    /*
    axios.post('https://api.podspast.com/new/')
      .then((response) => {
        if (response.data.successResponse) {

        } else {
          alert('not quite right');
          // tslint:disable-next-line
          console.log({ response });
        }
      });
      */
  },
});
